import request from '@/utils/request'

const url = 'notice'

/** 获取小区下拉框 */
export function searchEnoentNoticeList(data) {
  return request({
    url: `${url}/searchEnoentNoticeList`,
    method: 'post',
    data
  })
}
